import React from 'react';
import { BarChart3, TruckIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks/reduxHooks';
import { UserRole } from '../../types/auth';
import UnderDevelopment from '../../components/UnderDevelopment';

const ManageCleverPeSupply: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector(state => state.auth);
  
  // Get the role prefix for routes based on user role
  const getRolePrefix = () => {
    if (!user) return ''; // Default fallback
    
    switch (user.role) {
      case UserRole.ADMIN:
        return '/admin';
      case UserRole.SUPERADMIN:
        return '/superadmin';
      case UserRole.CLEVERPE_USER:
        return '/cleverpeuser';
      default:
        return '';
    }
  };
  
  // Get dashboard path based on user role
  const getDashboardPath = () => {
    return `${getRolePrefix()}/dashboard`;
  };
  
  // Navigate to the dashboard based on user role
  const handleDashboardClick = () => {
    navigate(getDashboardPath());
  };

  return (
    <UnderDevelopment
      title="CleverPe Supply+ Under Development"
      description="We're building an advanced supply chain management solution to streamline your operations. This feature will be available soon!"
      primaryColor="teal"
      secondaryColor="green"
      icon="Package"
      buttonColor="teal"
      featureBoxes={[
        {
          icon: "TruckIcon",
          title: "Inventory Management",
          description: "Track inventory levels, set reorder points, and manage your supply chain with real-time insights."
        },
        {
          icon: "BarChart3",
          title: "Analytics Dashboard",
          description: "Access comprehensive analytics and reporting tools to optimize your supply chain operations."
        }
      ]}
    />
  );
};

export default ManageCleverPeSupply; 